import emojioneOptions from './emojioneOptions';

const menuEmoijiOptions = {
  ...emojioneOptions,
  styles: {
    ...emojioneOptions.styles,
    height: '12pt',
    width: '12pt',
    margin: '0',
    marginBottom: '-3.5pt'
  }
};

export default menuEmoijiOptions;



/** WEBPACK FOOTER **
 ** ./src/images/menuEmojiOptions.js
 **/